import { defineComponent, openBlock, createElementBlock, createElementVNode, createTextVNode, toDisplayString, createVNode, unref, withCtx } from "vue";
import { CdrLink } from "@rei/cedar";
const _hoisted_1 = {
  class: "limited-time-offer"
};
const _hoisted_2 = {
  class: "limited-time-offer__content"
};
const learnMoreUrl = "/membership/mastercard/preapproval?trackingId=pdp_test_pre-approval";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CobrandLimitedTimeOffer",
  props: {
    cobrandLimitedTimeOfferDate: {
      default: "Oct 27"
    }
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handlePreApprovalCobrandLearnMore = () => {
      emit("metricsClick", {
        link: learnMoreUrl,
        linkName: "rei co-op mastercard_lto_learn more"
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_cache[7] || (_cache[7] = createElementVNode("strong", {
        class: "limited-time-offer__badge"
      }, "Limited-Time Offer", -1)), _cache[8] || (_cache[8] = createElementVNode("div", {
        class: "limited-time-offer__heading"
      }, [createElementVNode("h2", null, [createElementVNode("img", {
        src: "https://www.rei.com/dam/cap_capitalone_card_hex_web_xs.jpeg",
        alt: "R E I Co-op Mastercard"
      }), createElementVNode("span", null, " A $130 value for you! ")])], -1)), createElementVNode("div", _hoisted_2, [createElementVNode("p", null, [_cache[0] || (_cache[0] = createTextVNode(" Get $30 in card rewards")), _cache[1] || (_cache[1] = createElementVNode("sup", null, "§", -1)), _cache[2] || (_cache[2] = createTextVNode(" when you’re approved for the REI Co‑op")), _cache[3] || (_cache[3] = createElementVNode("sup", null, "®", -1)), _cache[4] || (_cache[4] = createTextVNode(" Mastercard")), _cache[5] || (_cache[5] = createElementVNode("sup", null, "®", -1)), createTextVNode(" by " + toDisplayString(_ctx.cobrandLimitedTimeOfferDate) + ". Plus, you can earn a $100 REI gift card after your first non‑REI purchase within 60 days from account opening. * Terms apply. ", 1)]), createVNode(unref(CdrLink), {
        href: learnMoreUrl,
        onClick: handlePreApprovalCobrandLearnMore
      }, {
        default: withCtx(() => _cache[6] || (_cache[6] = [createTextVNode(" Learn more ")])),
        _: 1,
        __: [6]
      })])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=CobrandLimitedTimeOffer2.mjs.map
